<template>
  <div class="details-tab">
    <div class="details-tab__header">
      <el-dropdown size="mini" style="margin-right: 20px">
              <span class="el-dropdown-link">
                Report Action<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item icon="el-icon-printer" @click.native="exportData(2, 10)">PDF</el-dropdown-item>
          <el-dropdown-item icon="fas fa-file-excel" @click.native="exportData(1, 10)">XL
          </el-dropdown-item>
          <el-dropdown-item icon="el-icon-s-promotion" @click.native="exportData(3,10)">Email</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-date-picker
          ref="datepicker"
          popper-class="custom-date-picker"
          size="mini"
          v-model="filter.dates"
          style="border-bottom: none"
          prefix-icon="el-icon-date"
          type="daterange"
          align="center"
          format="d MMM yy"
          :clearable="false"
          value-format="timestamp"
          range-separator=""
          start-placeholder="Start date"
          end-placeholder="End date"
          @change="setFilter"
          :picker-options="pickerOptions"
      >
      </el-date-picker>
      <el-select
          v-model="filter.filterBy"
          size="small"
          label="Filters"
          @change="selectFilter1">
        <el-option
            v-for="type in filters"
            :key="type.id"
            :label="type.name"
            :value="type.id"
        ></el-option>
      </el-select>
      <el-select
          v-model="filter.filterBy2"
          size="small"
          filterable
          style="margin-left: 40px;"
          @change="selectFilter2">
        <div v-if="filter.filterBy === 'createdByArr'">
          <el-option
              v-for="type in activeFilterData"
              :key="type.userId"
              :label="type.userName"
              :value="type.userId"
          ></el-option>
        </div>
        <div v-else>
          <el-option
              v-for="type in activeFilterData"
              :key="type"
              :label="type"
              :value="type"
          ></el-option>
        </div>
      </el-select>
    </div>
    <el-table
        :data="tableData"
        ref="table"
        row-key="accountid"
        size="small"
        border
        lazy
        height="calc(100vh - 130px)"
        :load="load"
        :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
        cell-class-name="t-cell"
        style="width: 100%">
      <el-table-column width="50">
      </el-table-column>
      <el-table-column
          :label="'Date'">
        <template slot-scope="scope">
          <div class="cell-wrap">
            <div v-if="!scope.row.transactionDate && !scope.row.firstItem">
              <el-row class="main-column-row" :gutter="20">
                <el-col :span="12">
                  <div class="first-row">Acc No.: <span class="t-value">{{scope.row.accno}}</span></div>
                  <div class="first-row">DB Code: <span class="t-value">{{scope.row.dbcode}}</span></div>
                </el-col>
                <el-col :span="12">
                  <div class="first-row">Acc Name: <span class="t-value">{{scope.row.accountname}}</span></div>
                  <div class="first-row">Beginning Balance <span class="t-value">{{scope.row.begbalance}}</span></div>
                </el-col>
              </el-row>
            </div>
            <div v-else>
              {{scope.row.transactionDate ? moment(scope.row.transactionDate).format("D MMM YY") : null}}
            </div>
<!--            <div class="items">-->
<!--              <div class="item" v-for="(item, index) in scope.row.arrTransaction" :key="index">-->
<!--                {{moment(item.transactionDate).format('D MMM YY')}}-->
<!--              </div>-->
<!--            </div>-->
          </div>
        </template>
      </el-table-column>
      <el-table-column
          width="150"
          :label="'ID'">
        <template slot-scope="scope">
          <div>
            <strong @click="cellClickID(scope.row)" style="color: #409EFF; cursor: pointer;">{{scope.row.transactionNo}}</strong>
          </div>
          <!-- {{scope.row.transactionNo}} -->
<!--          <div class="cell-wrap">-->
<!--            <div class="items">-->
<!--              <div class="item" v-for="(item, index) in scope.row.arrTransaction" :key="index">-->
<!--                {{item.transactionNo}}-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
        </template>
      </el-table-column>
      <el-table-column
          width="150"
          :label="'Entry type'">
        <template slot-scope="scope">
          {{scope.row.transactionType}}
        </template>
      </el-table-column>
      <el-table-column
          :label="'Description'">
        <template slot-scope="scope">
          {{scope.row.transactionDescription}}
        </template>
      </el-table-column>
      <el-table-column
          width="200"
          :label="'Created By'">
        <template slot-scope="scope">
          <div class="cell-wrap">
            <div class="items">
              <div class="item">
                {{ scope.row.userName }}
              </div>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
          width="120"
          :label="'Debit'">
        <template slot-scope="scope">
          <div style="text-align: right">
            {{(scope.row.debit && scope.row.debit !== '0') ? formatPrice(scope.row.debit) : null}}
          </div>
<!--          <div class="cell-wrap">-->
<!--            <div class="items">-->
<!--              <div class="item" v-for="(item, index) in scope.row.arrTransaction" :key="index">-->
<!--                {{ item.debit }}-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
        </template>
      </el-table-column>
      <el-table-column
          width="120"
          :label="'Credit'">
        <template slot-scope="scope">
          <div style="text-align: right">
            {{(scope.row.credit && scope.row.credit !== '0') ? formatPrice(scope.row.credit) : null}}
          </div>
<!--          <div class="cell-wrap">-->
<!--            <div class="items">-->
<!--              <div class="item" v-for="(item, index) in scope.row.arrTransaction" :key="index">-->
<!--                {{ item.credit }}-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
        </template>
      </el-table-column>
      <el-table-column
          width="120"
          :label="'End Balance'">
        <template slot-scope="scope">
          <div style="text-align: right">
            {{(scope.row.endbalance && scope.row.endbalance !== '0') ? formatPrice(scope.row.endbalance) : null}}
          </div>
        </template>
<!--        <template slot-scope="scope">-->
<!--          <div class="cell-wrap">-->
<!--            <div class="items">-->
<!--              <div class="item" v-for="(item, index) in scope.row.arrTransaction" :key="index">-->
<!--                {{ formatPrice(item.endbalance) }}-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </template>-->
      </el-table-column>
    </el-table>

    <editJournalEntryModal @updateList="getList" :showInfo="false" ref="editJournalEntryModal"/>

  </div>
</template>

<script>
const makeid = (length) =>  {
  var result           = '';
  var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  var charactersLength = characters.length;
  for ( var i = 0; i < length; i++ ) {
    result += characters.charAt(Math.floor(Math.random() *
        charactersLength));
  }
  return result;
}
import axios from "axios";
import moment from 'moment'
import editJournalEntryModal from '@/components/journalAndGl/editJournalEntryModal.vue'


export default {
  name: "GLADetails",
  components: {
    editJournalEntryModal
  },
  data() {
    return {
      tableData: [],
      expandRowKeys: [],
      moment: moment,
      pickerOptions: {
        shortcuts: [
          {
            text: "This month",
            onClick(picker) {
              const end = moment().endOf("month");
              const start = moment().startOf("month");
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Last month",
            onClick(picker) {
              const end = moment().endOf("month").subtract(1, "months");
              const start = moment().startOf("month").subtract(1, "months");
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Last 3 months",
            onClick(picker) {
              const end = moment().endOf("month").subtract(1, "months");
              const start = moment().startOf("month").subtract(3, "months");
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "This financial quarter",
            onClick(picker) {
              const end = moment().endOf("quarter");
              const start = moment().startOf("quarter");
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Last financial quarter",
            onClick(picker) {
              const end = moment().subtract(1, 'quarter').endOf('quarter');
              const start = moment().subtract(1, 'quarter').startOf('quarter');
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "This financial year",
            onClick(picker) {
              const end = moment().endOf("year");
              const start = moment().startOf("year");
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Last financial year",
            onClick(picker) {
              const end = moment().endOf("year").subtract(1, "year");
              const start = moment().startOf("year").subtract(1, "year");
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      filter: {
        dates: [],
        filterBy: null,
        filterBy2: null
      },
      filters: [
        { id: 'all', name: 'All' },
        { id: 'accNameArr', name: 'Account Name' },
        { id: 'dbCodeArr', name: 'DB Code' },
        { id: 'accNoArr', name: 'Account No.' },
        { id: 'trNoArr', name: 'ID' },
        { id: 'entryTypeArr', name: 'Entry Type' },
        { id: 'createdByArr', name: 'Created By' },
        { id: 'amountArr', name: 'Amount' }
      ],
      filterData: {}
    }
  },
  computed: {
    companyLayout() {
      return this.$store.getters.getCompanyLayout;
    },
    financialYearStartDate() {
      return this.companyLayout ? this.companyLayout.financialYearStartDate : null
    },
    activeFilterData() {
      return this.filterData[this.filter.filterBy]
    },
    financialYearStartDateFormatted () {
      return this.companyLayout && this.companyLayout.financialYearStartDate ? moment(this.companyLayout.financialYearStartDate, 'DD-MM-YYYY').format('YYYY-MM-DD') : null
    },
  },
  methods:{
    cellClickID(row) {
      let rowItem = { ...row }
      rowItem.id = rowItem.tid
      this.$refs['editJournalEntryModal'].openModalFromJournalEntry(rowItem)
    },
    loadList2() {
      this.filter.dates = [
        this.companyLayout.financialYearStartDate
            ? moment(this.companyLayout.financialYearStartDate, "DD-MM-yyyy")
            : moment("2022-01-01", "DD-MM-yyyy"),
        moment(),
      ];
      this.loadList(this.filter.dates[0], this.filter.dates[1])
    },
    async loadList(stateStart, stateEnd, filterEntity = 'all', filterEntityTypeId = 'all') {
      try {
        let loader = this.$loading.show();
        axios.defaults.headers.common["Authorization"] = "Bearer " + sessionStorage.getItem("token");
        axios.defaults.headers.common["X-Timezone-Offset"] = (new Date().getTimezoneOffset() / 60).toString();
        const { data } = await axios.get(`/api/v1/general-ledger/details/beginBalance?companyId=${this.$route.query.companyId}&startDate=${moment(stateStart).format('MM-DD-YYYY')}&endDate=${moment(stateEnd).format('MM-DD-YYYY')}&filterEntity=${filterEntity ? filterEntity : 'all'}&filterEntityTypeId=${filterEntityTypeId ? filterEntityTypeId : 'all'}`)
        const madata = data.data.map(val => ({...val, ...{ hasChildren: true, children: [] }}))
        this.tableData = madata
        const filters = await axios.get(`/api/v1/general-ledger/details/getFilterData?companyId=${this.$route.query.companyId}&startDate=${moment(stateStart).format('MM-DD-YYYY')}&endDate=${moment(stateEnd).format('MM-DD-YYYY')}`)
        this.filterData = filters.data.data
        loader.hide()
      } catch (err) {
        console.log(err)
      }
    },
    load(tree, treeNode, resolve) {
      console.log('tree, treeNode, resolve', tree, treeNode, resolve)
      try {
        let loader = this.$loading.show();
        axios.defaults.headers.common["Authorization"] = "Bearer " + sessionStorage.getItem("token");
        axios.defaults.headers.common["X-Timezone-Offset"] = (new Date().getTimezoneOffset() / 60).toString();
        axios.get(`/api/v1/general-ledger/details/transactionEntry?companyId=${this.$route.query.companyId}&accountId=${tree.accountid}&startDate=${moment(this.filter.dates[0]).format('MM-DD-YYYY')}&endDate=${moment(this.filter.dates[1]).format('MM-DD-YYYY')}&filterEntity=${this.filter.filterBy ? this.filter.filterBy : "all"}&filterEntityTypeId=${this.filter.filterBy2 ? this.filter.filterBy2 : 'all'}`).then(response => {
          response.data.data.forEach((val, index) => {
            if (index == 0) val.firstItem = true
            let s4 = () => {
              return Math.floor((1 + Math.random()) * 0x10000)
                  .toString(16)
                  .substring(1);
            }
            val.accountid = s4()
          })
          resolve(response.data.data)

          loader.hide()
        })
      } catch (err) {
        console.log(err)
      }
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(",", ".");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    setFilter(val) {
      this.tableData = []
      if (!val) {
        this.filter.dates = [];
      } else {
        const start = moment(this.filter.dates[0]).format("yyyy-MM-DD");
        const end = moment(this.filter.dates[1]).format("yyyy-MM-DD");
        this.loadList(start, end, this.filter.filterBy, this.filter.filterBy2);
      }
    },
    selectFilter1(val) {
      console.log('- val -', val)
      this.filter.filterBy2 = null
      const start = moment(this.filter.dates[0]).format("yyyy-MM-DD");
      const end = moment(this.filter.dates[1]).format("yyyy-MM-DD");
      this.loadList(start, end, val, 'all')
    },
    async selectFilter2(val) {
      try {
        this.tableData = []
        const start = moment(this.filter.dates[0]).format("yyyy-MM-DD");
        const end = moment(this.filter.dates[1]).format("yyyy-MM-DD");
        await this.loadList(start, end, this.filter.filterBy, val)
      } catch (err) {
        console.log(err)
      }
    },
    loadTransactions(accountid) {
      return new Promise((resolve, reject) => {
        let loader = this.$loading.show();
        axios.defaults.headers.common["Authorization"] = "Bearer " + sessionStorage.getItem("token");
        axios.defaults.headers.common["X-Timezone-Offset"] = (new Date().getTimezoneOffset() / 60).toString();
        axios.get(`/api/v1/general-ledger/details/transactionEntry?companyId=${this.$route.query.companyId}&accountId=${accountid}&startDate=${moment(this.filter.dates[0]).format('MM-DD-YYYY')}&endDate=${moment(this.filter.dates[1]).format('MM-DD-YYYY')}&filterEntity=${this.filter.filterBy ? this.filter.filterBy : "all"}&filterEntityTypeId=${this.filter.filterBy2 ? this.filter.filterBy2 : 'all'}`).then(response => {
          response.data.data.forEach(val => {
            let s4 = () => {
              return Math.floor((1 + Math.random()) * 0x10000)
                  .toString(16)
                  .substring(1);
            }
            val.accountid = s4()
          })
          resolve(response.data.data)

          loader.hide()
        })
      })
    },
    async exportData (typeExportId, typeId) {
      let email = null
      try {

        if (typeExportId === 3) {
          const { value } = await this.$prompt('Please input your e-mail', '', {
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancel',
            inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
            inputErrorMessage: 'Invalid Email'
          })
          email = value
        }
        const payload = {
          companyId: +this.$route.query.companyId,
          typeId: typeId,
          typeExportId: typeExportId,
          startDate: this.financialYearStartDateFormatted ? this.financialYearStartDateFormatted : '2022-01-01',
          endDate: moment().format('YYYY-MM-DD'),
          email: email,
          optionalField: {
            name: this.filter.filterBy ? this.filter.filterBy : "all",
            value: this.filter.filterBy2 ? this.filter.filterBy2 : 'all'
          },
          filterBy: null,
          filterValue: null,
          orderBy: null,
          order: null
        }
        let loader = this.$loading.show()
        axios.defaults.headers.common['Authorization'] =
            'Bearer ' + sessionStorage.getItem('token')
        axios.defaults.headers.common['X-Timezone-Offset'] = (
            new Date().getTimezoneOffset() / 60
        ).toString()
        const { data } = await axios.post(`/api/v1/export`, payload)
        switch (typeExportId) {
          case 2: // pdf
          case 1: // xl
            window.open(data.file.downloadPath).focus()
            break
        }
        loader.hide()
      } catch (err) {
        console.log(err)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.details-tab {
  &__header {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 20px;
    align-items: center;
  }
}
/deep/.t-cell {
  vertical-align: bottom;
}
.items {
  margin-top: 20px;
}
.item {
  margin-bottom: 5px;
  &:last-child {
    margin-bottom: 0;
  }
}
.main-column-row {
  display: flex;
  justify-content: space-between;
  .first-row {
    margin-right: 10px;
    .t-value {
      font-weight: bold;
    }
  }
}

.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}
</style>
